export default "__VITE_ASSET__BrJIbDHB__"